<template>
  <div>
    <!-- <pre>{{courseSetting.course_class_type}}</pre> -->
    <!-- {{Modaltype}} -->
    <!-- <pre>{{ QuestionModal }}</pre> -->

    <!-- {{lessonId}}
          {{course_id}}
          {{sectionType}} -->

    <!--  <div v-if="Modaltype == 'Question'">
      <div
        class="light-border p-4 my-2"
        v-for="(eachQuestion, index) in QuestionModal"
        :key="index"
      >
      <div v-if="eachQuestion.questions">
        <p class="question-container">{{ eachQuestion.questions.title }}</p>
        <p class="font-bold float-right">
          Points: <span>{{ eachQuestion.questions.point }}</span>
        </p>
      <input type="file" v-if="eachQuestion.questions.question_input_type_id === 7"
      @change="showingNotImplemented()"
      />

        <vs-textarea
          v-if="
            eachQuestion.questions.question_input_type_id === 1 ||
            eachQuestion.questions.question_input_type_id === 2
          "
          label="Write your answer here"
          v-model="eachQuestion.short_answer"
        />

        <LinkPreviewComponent :question_detail="eachQuestion.questions">
        </LinkPreviewComponent>

        <div
          v-if="
            eachQuestion.questions.question_input_type_id === 3
          "
        >
          <div
            class="options-holder"
            v-for="(options, optionIndex) in eachQuestion.questions
              .questions_options"
            :key="optionIndex"
          >
         
            <vs-radio
              v-model="eachQuestion.answer"
              :name="`custom${index}`"
              :vs-value="options.id"
              >{{ options.option_name }}</vs-radio
            >
          </div>
        </div>

        <div
          v-if="
            eachQuestion.questions.question_input_type_id === 5
          "
        >

        <v-select :options="eachQuestion.questions.questions_options"
                      v-model="eachQuestion.answer"
              :name="`custom${index}`"
              label="option_name"
              :reduce="option=>option.id"

        ></v-select>
        </div>

        <div
          v-if="
            eachQuestion.questions.question_input_type_id === 4 ||
            eachQuestion.questions.question_input_type_id === 6
          "
        >
          <div
            class="options-holder"
            v-for="(options, index) in eachQuestion.questions.questions_options"
            :key="index"
          >
            <vs-checkbox v-model="eachQuestion.answer" :vs-value="options.id">{{
              options.option_name
            }}</vs-checkbox>
          </div>
        </div>
        <p><b>Feedback : </b> {{ eachQuestion.questions.feedback }}</p>
      </div>
      <div class="text-right">
        <vs-button
          class="mx-1"
          color="primary"
          type="filled"
          @click="answerQuestionSubmit()"
          >Save</vs-button
        >
      </div>
    </div>
    </div> -->

    <!-- For Assignment -->
    <div>
      <!-- {{eachQuestion}} -->
      <div
        class="light-border p-4 my-2"
        v-for="(eachQuestion, index) in QuestionModal"
        :key="index"
      >
        <div v-if="eachQuestion">
          <!-- <pre>{{eachQuestion}}</pre> -->

          <p class="question-container">{{ eachQuestion.title }}</p>
          <p class="font-bold float-right">
            Points: <span>{{ eachQuestion.point }}</span>
          </p>

          <vs-textarea
            v-if="
              eachQuestion.question_input_type_id === 1 ||
              eachQuestion.question_input_type_id === 2
            "
            label="Write your answer here"
            v-model="eachQuestion.short_answer"
          />

          <LinkPreviewComponent :question_detail="eachQuestion">
          </LinkPreviewComponent>
          <!-- {{eachQuestion.question_input_type_id}} -->

          <FileUpload
            v-if="eachQuestion.question_input_type_id === 7"
            :question_detail_index="index"
            :file_repository_id="repository_id"
            @getFileId="getIdFile"
            :filesInfo="
              eachQuestion.student_class_answers
                ? eachQuestion.student_class_answers.files
                : []
            "
            @deletedIndex="deletedIndex"
            :multiple="true"
          >
          </FileUpload>

          <div v-if="eachQuestion.question_input_type_id === 3">
            <div
              class="options-holder"
              v-for="(options, index) in eachQuestion.questions_options"
              :key="index"
            >
              <vs-radio
                v-model="eachQuestion.answer"
                :name="`custom${index}`"
                :vs-value="options.id"
                :ref="`custom${index}`"
              >
                <p>
                  <span>{{ options.option_name }}</span>
                  <span>
                    <img
                      class="answer_validation_icon"
                      src="../../../../../src/assets/images/pages/courses/QA_Icon/correct.png"
                      v-if="options.is_answer && showAnswerNow"
                    />
                  </span>
                  <span>
                    <img
                      class="answer_validation_icon"
                      src="../../../../../src/assets/images/pages/courses/QA_Icon/incorrect.png"
                      v-if="
                        !options.is_answer &&
                        showAnswerNow &&
                        checkifSelected(
                          eachQuestion.Questiontype,
                          eachQuestion.answer,
                          options.id
                        )
                      "
                    />
                  </span>
                </p>
              </vs-radio>
            </div>
          </div>

          <div v-if="eachQuestion.question_input_type_id === 5">
            <v-select
              class="options-holder"
              v-model="eachQuestion.answer"
              :name="`custom${index}`"
              :options="eachQuestion.questions_options"
              :reduce="(option) => option.id"
              label="option_name"
            />
          </div>

          <div
            v-if="
              eachQuestion.question_input_type_id === 4 ||
              eachQuestion.question_input_type_id === 6
            "
          >
            <div
              class="options-holder"
              v-for="(options, index) in eachQuestion.questions_options"
              :key="index"
            >
              <!-- <pre>{{eachQuestion}}</pre> -->
              <vs-checkbox
                v-model="eachQuestion.answer"
                :vs-value="options.id"
                :ref="`custom${index}`"
              >
                <p>
                  <span>{{ options.option_name }}</span>
                  <span>
                    <img
                      class="answer_validation_icon"
                      src="../../../../../src/assets/images/pages/courses/QA_Icon/correct.png"
                      v-if="options.is_answer && showAnswerNow"
                    />
                  </span>
                  <span>
                    <img
                      class="answer_validation_icon"
                      src="../../../../../src/assets/images/pages/courses/QA_Icon/incorrect.png"
                      v-if="
                        !options.is_answer &&
                        showAnswerNow &&
                        checkifSelected(
                          eachQuestion.Questiontype,
                          eachQuestion.answer,
                          options.id
                        )
                      "
                    />
                  </span>
                </p>
              </vs-checkbox>
              <br />
            </div>
          </div>

          <vs-divider />

          <p>
            <b>Feedback : </b
            >{{
              eachQuestion.student_class_answers
                ? eachQuestion.student_class_answers.teacher_comment
                : ""
            }}
          </p>
          <!-- {{ eachQuestion.links }} -->
        </div>
      </div>

      <div class="text-right">
        <div class="">
          <!-- <vs-button class="mx-1" color="dark" type="border">Cancel</vs-button> -->
          <vs-button
            class="mx-1"
            color="primary"
            type="filled"
            @click="answerQuestionSubmit('save')"
            >Save</vs-button
          >
          <vs-button
            class="mx-1"
            color="primary"
            type="filled"
            @click="answerQuestionSubmit('submit')"
            >Save and Submit</vs-button
          >
        </div>
        <!-- <div v-else>

            <vs-button class="mx-1" color="primary" type="filled"
            @click="checkValidInvalidAnswers()"
            v-if="!showAnswerNow"
            >Check answer</vs-button>

            <vs-button class="mx-1" color="primary" type="filled"
            @click="hideValidInvalidAnswers()" 
            v-if="showAnswerNow"
            >Hide answer</vs-button>

          </div> -->
      </div>
    </div>
  </div>
</template>

<script>
//courses ->type:1, Lesson->type:2, Topics->3
import LinkPreviewComponent from "./LinkPreviewComponent";
import { getRepoId } from "@/api/course/courseapi";
import { SubmitAnswer } from "@/api/classes";
import vSelect from "vue-select";
import FileUpload from "./FileUpload";
export default {
  name: "QuestionModal",
  props: {
    QuestionModal: {
      type: Array,
      required: true,
      default: () => {},
    },
    Modaltype: {
      type: String,
      required: true,
      default: "Question",
    },
    lessonId: {
      type: Number,
      default: null,
    },
    class_id: {
      type: Number,
      default: null,
    },
    sectionType: {
      type: Number,
      default: null,
    },
    platform_customer_id: {},
    courseSetting: {},
  },
  components: {
    LinkPreviewComponent,
    vSelect,
    FileUpload,
  },
  data() {
    return {
      showAnswerNow: false,
      testingrad: "",
      repository_id: null,
      // answers:[]
    };
  },
  created() {
    if (this.Modaltype == "Question") {
      this.setQuestionModalAnswer();
    } else {
      this.setQuestionAssignmentAnswer();
    }

    this.getRepositoryId();
  },
  methods: {
    async getRepositoryId() {
      try {
        const customer_id =
          this.platform_customer_id == null
            ? localStorage.getItem("customer_id")
            : this.platform_customer_id;
        const payload = {
          client: true,
          platform_module_id: 49,
        };

        const { data } = await getRepoId(customer_id, payload);
        this.repository_id = data.data[0].id;
      } catch (error) {
        console.warn(error);
      }
    },
    checkifSelected(Questiontype, correct_answer_id, correct_options_id) {
      // console.log(Questiontype)
      // console.log(correct_answer_id)
      if (Questiontype === "checkbox") {
        //console.log('Checkbox')
        if (correct_answer_id.includes(correct_options_id)) {
          return true;
        } else {
          return false;
        }
      } else if (Questiontype === "radio") {
        if (correct_answer_id === correct_options_id) {
          return true;
        } else {
          return false;
        }
      }
    },
    hideValidInvalidAnswers() {
      this.showAnswerNow = false;
    },
    checkValidInvalidAnswers() {
      this.showAnswerNow = true;
    },
    showingNotImplemented() {
      alert("Not Yet Implemented");
    },
    answerQuestionSubmit(submit_type) {
      //console.log('Submitted')
      let payload = [];
      console.log(this.QuestionModal);
      if (this.Modaltype == "Question") {
        payload = this.QuestionModal.map((ele) => {
          return {
            class_id: this.class_id,
            lesson_id: this.lessonId,
            type: this.sectionType,
            class_assignment_or_question_id: ele.id,
            question_bank_question_answer_id:
              ele.Questiontype === "radio" ? [ele.answer] : ele.answer,
            question_type: 2, // question bank
            short_answer: ele.short_answer,
            Questiontype: ele.Questiontype,
            files: ele.files,
          };
        }).filter((ele) => {
          if (ele.Questiontype == "radio" || ele.Questiontype == "checkbox") {
            return ele.question_bank_question_answer_id.length > 0;
          } else if (ele.Questiontype == "fileupload") {
            return ele.files.length > 0;
          } else {
            return ele.short_answer !== null;
          }
        });
      } else {
        payload = this.QuestionModal.map((ele) => {
          return {
            class_id: this.class_id,
            lesson_id: this.lessonId,
            type: this.sectionType,
            assignment_question_id: ele.id,
            assignment_question_answer_id:
              ele.Questiontype === "radio" ? [ele.answer] : ele.answer,
            question_type: 1, //assignment
            short_answer: ele.short_answer,
            Questiontype: ele.Questiontype,
            files: ele.files,
          };
        }).filter((ele) => {
          if (ele.Questiontype == "radio" || ele.Questiontype == "checkbox") {
            return ele.assignment_question_answer_id.length > 0;
          } else if (ele.Questiontype == "fileupload") {
            return ele.files.length > 0;
          } else {
            return ele.short_answer !== null;
          }
        });
      }

      console.log(payload);
      if (payload.length) {
        this.saveAnswerQuestion(payload, submit_type);
      }
    },
    async saveAnswerQuestion(payload, submit_type) {
      try {
        console.log(this.QuestionModal);
        const answers = {
          answers: payload,
          class_id: this.class_id,
          platform_customer_id: this.platform_customer_id,
          submit_type: submit_type === "save" ? "draft" : "final_submit",
        };
        console.log(answers);
        const data = await SubmitAnswer(answers);
        console.log(data);
        let successMessage = "";
        if (this.Modaltype == "Question") {
          successMessage = "Question Answer Saved Succesfully";
        } else {
          successMessage = "Assignmnent Answer Saved Successfully";
        }
        this.$vs.notify({
          title: "Success",
          text: `${successMessage}`,
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "success",
          time: 3000,
        });
      } catch (error) {
        console.log(error);
        this.$vs.notify({
          title: "error",
          text: "Something Went Wrong",
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "danger",
          time: 3000,
        });
      }
    },
    getAnswerId(ele) {
      console.log(ele);
      if (ele.Questiontype === "radio") {
        if (ele.answer == null) {
          return [];
        }
      } else {
        return ele.answer;
      }
    },
    setQuestionModalAnswer() {
      console.log(this.QuestionModal);
      this.QuestionModal.forEach((ele) => {
        if (
          ele.questions.question_input_type_id == "3" ||
          ele.questions.question_input_type_id == "5"
        ) {
          console.log(ele.student_class_answers);
          this.$set(
            ele,
            "answer",
            ele.student_class_answers !== null
              ? ele.student_class_answers.question_bank_question_answer_id[0]
              : null
          );
          this.$set(ele, "short_answer", null);
          ele.Questiontype = "radio";
        } else if (
          ele.questions.question_input_type_id == "4" ||
          ele.questions.question_input_type_id == "6"
        ) {
          // this.$set(ele, 'answer', [])
          this.$set(
            ele,
            "answer",
            ele.student_class_answers !== null
              ? ele.student_class_answers.question_bank_question_answer_id
              : []
          );

          this.$set(ele, "short_answer", null);

          ele.Questiontype = "checkbox";
        } else if (ele.questions.question_input_type_id == "7") {
          this.$set(
            ele,
            "files",
            ele.student_class_answers !== null
              ? ele.student_class_answers.question_bank_question_answer_id
              : []
          );

          this.$set(ele, "short_answer", null);

          ele.Questiontype = "fileupload";
          console.log("hi 7");
        } else {
          this.$set(
            ele,
            "short_answer",
            ele.student_class_answers !== null
              ? ele.student_class_answers.short_answer
              : []
          );
          // this.$set(ele, 'short_answer', null)
          ele.Questiontype = "shortanswer";
        }
      });
    },
    setQuestionAssignmentAnswer() {
      console.log(this.QuestionModal);
      this.QuestionModal.forEach((ele) => {
        console.log(ele.question_input_type_id);
        if (
          ele.question_input_type_id == "3" ||
          ele.question_input_type_id == "5"
        ) {
          console.log(ele.student_class_answers);
          this.$set(
            ele,
            "answer",
            ele.student_class_answers !== null
              ? ele.student_class_answers.assignment_question_answer_id[0]
              : null
          );
          this.$set(ele, "short_answer", null);
          ele.Questiontype = "radio";
        } else if (
          ele.question_input_type_id == "4" ||
          ele.question_input_type_id == "6"
        ) {
          // this.$set(ele, 'answer', [])
          this.$set(
            ele,
            "answer",
            ele.student_class_answers !== null
              ? ele.student_class_answers.assignment_question_answer_id
              : []
          );

          this.$set(ele, "short_answer", null);

          ele.Questiontype = "checkbox";
        } else if (ele.question_input_type_id == "7") {
          this.$set(
            ele,
            "files",
            ele.student_class_answers !== null
              ? ele.student_class_answers.files.map((eachFile) => {
                  return {
                    id: eachFile.pivot.id,
                    file_id: eachFile.pivot.file_id,
                  };
                })
              : []
          );

          this.$set(ele, "short_answer", null);

          ele.Questiontype = "fileupload";
          console.log("hi 7");
        } else {
          this.$set(
            ele,
            "short_answer",
            ele.student_class_answers !== null
              ? ele.student_class_answers.short_answer
              : null
          );
          // this.$set(ele, 'short_answer', null)
          ele.Questiontype = "shortanswer";
        }
      });
    },
    getIdFile(obj) {
      this.QuestionModal[obj.question_index].files.push({
        id: null,
        file_id: obj.file_id,
      });
      console.log(obj);
    },
    deletedIndex({ question_detail_index, fileIndex }) {
      console.log("hi");
      this.QuestionModal[question_detail_index].files.splice(fileIndex, 1);
      this.QuestionModal[
        question_detail_index
      ].student_class_answers.files.splice(fileIndex, 1);
    },
  },
};
</script>

<style scoped>
.answer_validation_icon {
  float: right;
  position: relative;
  top: -5px;
  left: 10px;
  width: 25px;
}
</style>